import {
  Children,
  cloneElement,
  isValidElement,
  useState,
  type PointerEvent,
  type PropsWithChildren,
  type ReactElement,
} from 'react';
import { Tooltip } from '@sib/ui';

type RowElement = ReactElement<{
  onPointerEnter?: (event: PointerEvent<HTMLTableRowElement>) => void;
}>;

interface DataTableRowTooltipProps extends PropsWithChildren {
  content: string;
}

export const DataTableRowTooltip = ({
  content,
  children,
}: DataTableRowTooltipProps) => {
  const [alignOffset, setAlignOffset] = useState(0);
  const child = Children.only(children);

  if (!isValidElement(child)) return children;

  const rowChild = child as RowElement;
  const childOnPointerEnter = rowChild.props.onPointerEnter;

  const handlePointerEnter = (event: PointerEvent<HTMLTableRowElement>) => {
    childOnPointerEnter?.(event);
    setAlignOffset(
      Math.round(
        event.clientX - event.currentTarget.getBoundingClientRect().left
      )
    );
  };

  return (
    <Tooltip
      content={content}
      TooltipTriggerProps={{ asChild: true }}
      TooltipContentProps={{
        side: 'top',
        align: 'start',
        alignOffset,
        withArrow: false,
      }}
    >
      {cloneElement(rowChild, {
        onPointerEnter: handlePointerEnter,
      })}
    </Tooltip>
  );
};
